import { API_ENDPOINT } from "../constants";
import { HTTP } from "./http";

export const FlowsService = {
  getFlows: (account_id: number) => {
    return HTTP.get<any, any>(`${API_ENDPOINT.BOT_V3}flows/${account_id}`);
  },

  addFlows: (name: string, account_id: number) => {
    return HTTP.post<any, any>(`${API_ENDPOINT.BOT_V3}flows/register`, { name, account_id });
  },
};
